import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { useStores } from "../../store/stores.js";
import { __ } from "../../utils/i18n.js";
const NoticeBannerActiveNoCookies = observer(()=>{
    const { optionStore: { publicCookieCount, busySettings, isBannerActive } } = useStores();
    return isBannerActive && !publicCookieCount && !busySettings && /*#__PURE__*/ _jsx("div", {
        className: "notice notice-warning inline below-h2 notice-alt",
        style: {
            margin: "10px 0 0 0"
        },
        children: /*#__PURE__*/ _jsx("p", {
            children: __("The cookie banner is activated, but unfortunately you have not yet created or enabled services.")
        })
    });
});
export { NoticeBannerActiveNoCookies };
